module.exports = typeof function foo() {}.name === 'string'; // when function names are minified, checking for "foo" would break



//////////////////
// WEBPACK FOOTER
// ./~/function.prototype.name/helpers/functionsHaveNames.js
// module id = 187
// module chunks = 35783957827783 172322841747965